// src/components/SplashScreen.jsx
import React, { useEffect, useState } from 'react';
import '../styles/SplashScreen.css';

const SplashScreen = ({ onFinish }) => {
  const [isAnimating, setIsAnimating] = useState(true);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Prevent body scroll during splash
    document.body.style.overflow = 'hidden';

    // Start fade out after zoom animation (2 seconds)
    const fadeTimer = setTimeout(() => {
      setIsAnimating(false);
    }, 2000);

    // Remove splash screen completely
    const removeTimer = setTimeout(() => {
      setIsVisible(false);
      document.body.style.overflow = '';
      if (onFinish) onFinish();
    }, 2500); // 2s zoom + 0.5s fade

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
      document.body.style.overflow = '';
    };
  }, [onFinish]);

  if (!isVisible) return null;

  return (
    <div className={`splash-screen ${!isAnimating ? 'fade-out' : ''}`}>
      <div className="splash-overlay">
        <div className="splash-logo-container">
          <img 
            src="/images/UtterRadioLogo.png" 
            alt="Utter Radio" 
            className={`splash-logo ${isAnimating ? 'zoom-in' : ''}`}
          />
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;